import { apiRequest } from "@/services";
import * as env from '@/config/env';

export const setChangeRequests = async ({ commit }, payload) => {
    try {
        const { companyId, taskId } = payload;

        const resp = await apiRequest(
            "get",
            env.TASK_CHANGE_REQUESTS,
            null,
            null,
            {
                params: { companyId, taskId }
            }
        );
        if (resp.status === 200 && resp.data?.status) {
            const data = resp.data.data || [];
            commit("setChangeRequests", data); // replace toàn bộ
            return data;
        }

        commit("setChangeRequests", []);
        return [];

    } catch (error) {
        console.error("ERROR setChangeRequests:", error);
        commit("setChangeRequests", []);
        return [];
    }
};

export const fetchChangeRequests = async ({ commit }, { taskId, companyId }) => {
    try {
        const res = await apiRequest(
            "get",
            "/api/v1/task-change-requests",
            null,
            null,
            {
                params: { taskId, companyId: companyId }
            }
        );

        const data = Array.isArray(res.data.data) ? res.data.data : [];

        commit("setChangeRequests", {
            data,
            op: "replace"
        });

    } catch (err) {
        console.error("❌ fetchChangeRequests error", err);
    }
};